import { FormActions } from "../../components/common/FormActions";
import { API_PAYMENT_MODES_CONFIGURABLES } from "../../utils/apis";
import {
  beautify,
  createActivateAction,
  createDeactivateAction,
  createDeleteAction,
  createViewEdit,
  formatDate,
  getForm,
  returnObject,
  stringifyName,
} from "../../utils/helpers";
import { URL_PAYMENT_MODES_CONFIGURABLES } from "../../utils/urls";

export const usePaymentModesConfigurables = () => {
  const tableColumns = () => [
    { id: "mode", header: "Payment Mode", filter: true },
    { id: "description", header: "Description", filter: true },
    {
      id: "active",
      header: "Active",
      filter: {
        type: "select",
        options: [
          { name: "Active", id: true },
          { name: "Inactive", id: false },
        ],
      },
    },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      const row = {
        ...item,
        created_at: formatDate(item.created_at),
        mode: item?.mode,
        description: beautify(item?.description),
        active: item?.active ? "Active" : "Inactive",
        actions: (
          <FormActions
            actions={[
              ...createViewEdit(URL_PAYMENT_MODES_CONFIGURABLES, item?.id),

              ...returnObject(item?.active, [
                createDeactivateAction(
                  `${API_PAYMENT_MODES_CONFIGURABLES}${item?.id}/`,
                  item?.mode,
                ),
              ]),
              ...returnObject(!item?.active, [
                createActivateAction(
                  `${API_PAYMENT_MODES_CONFIGURABLES}${item?.id}/`,
                  item?.mode,
                ),
              ]),
              createDeleteAction(
                `${API_PAYMENT_MODES_CONFIGURABLES}${item?.id}/`,
                item?.mode,
              ),
            ]}
          />
        ),
      };
      return row;
    }),
  ];

  const viewData = (item: any) => {
    return {
      payment_mode: item?.mode,
      description: beautify(item?.description),
      active: beautify(item?.active),
      created_by: stringifyName({ ...item?.created_by }),
      updated_at: formatDate(item?.updated_at),
      created_at: formatDate(item?.created_at),
    };
  };

  const formRoute = getForm(URL_PAYMENT_MODES_CONFIGURABLES);
  return { tableColumns, tableData, formRoute, viewData };
};
